import React from "react";
import { ChevronRight } from "lucide-react";

export default function OuterModalListItem({ name, subtitle, clickHandler, testId }) {
  return (
    <button
      type="button"
      onClick={clickHandler}
      aria-label={subtitle ? `${name}, ${subtitle}` : name}
      data-testid={testId || "food-search-result"}
      data-food-name={name}
      className="w-full flex items-center justify-between gap-3 px-4 py-3 rounded-xl border border-gray-200 bg-white text-left hover:border-orange-200 hover:bg-orange-50/50 transition-colors group focus:outline-none focus:ring-0"
    >
      <div className="min-w-0 flex-1">
        <h3 className="font-medium text-gray-900 truncate">{name}</h3>
        {subtitle && (
          <p className="text-sm text-gray-500 truncate mt-0.5">{subtitle}</p>
        )}
      </div>
      <ChevronRight className="w-5 h-5 text-gray-300 group-hover:text-orange-500 shrink-0" />
    </button>
  );
}
